import { CKLA } from 'app/constants/api.constants'
import Http from 'app/services/core/Http.service'

export default class ContentTokenService extends Http {
  getContentToken(kcToken: string) {
    const url = `${CKLA}/api/access`
    const body = {
      kcToken,
      pathname: window.location.pathname,
    }
    return this.post(url, {}, body)
  }

  createTokenHeartbeat(onErrorCb: () => void) {
    const TEN_MIN = 1000 * 60 * 10
    window.contentTokenHb = setInterval(async () => {
      try {
        await this.getContentToken(window.kc.token ?? '')
      } catch (e) {
        console.error(`Content token check error: ${e}`)
        onErrorCb()
      }
    }, TEN_MIN)
  }
}
